import { classNamesFor } from '../../../utils/classNames';

const classNamesFactory = classNamesFor('Dropdown');

export const dropdownClassNames = {
  root: classNamesFactory.root(),
  singleAutoComplete: classNamesFactory.attribute('singleAutoComplete'),
  multiAutoComplete: classNamesFactory.attribute('multiAutoComplete'),
  hiddenInput: classNamesFactory.element('hiddenInput'),
  container: classNamesFactory.element('container'),
  toggle: classNamesFactory.element('toggle'),
  label: classNamesFactory.element('label'),
  selectedItems: classNamesFactory.element('selectedItems'),
  caret: classNamesFactory.element('caret'),
  hint: classNamesFactory.element('hint'),
  prefix: classNamesFactory.element('prefix'),
  prefixOutside: classNamesFactory.element('prefixOutside'),
  placeholder: classNamesFactory.element('placeholder'),
  searchInputContainer: classNamesFactory.element('searchInputContainer'),
  searchInput: classNamesFactory.element('searchInput'),
  menuList: classNamesFactory.element('menuList'),
  customItemHint: classNamesFactory.element('customItemHint'),
  dropdownContainer: classNamesFactory.element('dropdownContainer'),
  menuItem: classNamesFactory.element('menuItem'),
  groupHeaderItem: classNamesFactory.element('groupHeaderItem'),
  noResultsMessage: classNamesFactory.element('noResultsMessage'),
  popper: classNamesFactory.element('popper'),
  suffixOutside: classNamesFactory.element('suffixOutside'),
  chipDisplay: classNamesFactory.element('chipDisplay'),
  open: classNamesFactory.attribute('open'),
  sizeSmall: classNamesFactory.attribute('small'),
  sizeMedium: classNamesFactory.attribute('medium'),
  sizeLarge: classNamesFactory.attribute('large'),
  disabled: classNamesFactory.globalClassNames.disabled,
  readOnly: classNamesFactory.globalClassNames.readOnly,
  error: classNamesFactory.globalClassNames.error,
  success: classNamesFactory.globalClassNames.success,
};
